import React, { useState, useEffect } from 'react';
import { ChevronUp } from "lucide-react";

function BotaoSubir() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    showButton && (
      <button
        onClick={scrollToTop}
        className="fixed bottom-20 right-6 bg-black text-white p-3 rounded-full shadow-lg hover:bg-gray-800 transition-transform duration-300 transform hover:scale-110 z-20" // Aumentei o z-index para ficar acima do WhatsApp
      >
        <ChevronUp size={24} />
      </button>
    )
  );
}

export default BotaoSubir;
